import GridRowLabel from 'components/Grid/GridRowLabel';

const HEADER_CONFIG = {
  readOnly: true,
  valueViewer: (props: any) => <GridRowLabel {...props} />,
};

export const TABLE_HEADER_CONFIG = {
  ...HEADER_CONFIG,
  className: 'table-header formatter-cell division-bottom-only',
};

export const ROW_HEADER_CONFIG = {
  ...HEADER_CONFIG,
  className: '',
};

export const BOLD_DIVISION_ROW_HEADER_CONFIG = {
  ...HEADER_CONFIG,
  className: 'subtitle-bold division-bottom-only',
};
export const BOLD_ROW_HEADER_CONFIG = {
  className: 'subtitle-bold',
};
export const BACKSOLVE_ROW_HEADER_CONFIG = {
  ...HEADER_CONFIG,
  className: '',
};
export const BACKSOLVE_ROW_SECURITY_CONFIG = {
  ...HEADER_CONFIG,
  className: 'read-only subtitle-indented',
};

export const ALLOCATION_METHOD_ALIAS = 'allocation_method';
export const VALUATION_APPROACH_GPC_ALIAS = 'valuation_approach_gpc';
export const TARGET_VALUE_ALIAS = 'target_value';
export const CAP_TABLE_ALIAS = 'cap_table';

export const METRICS = ['Market Cap', 'Enterprise Value', 'LTM Revenue', 'LTM EBITDA', 'NTM Revenue', 'NTM EBITDA'];

export const METRICS_KEYS_MAP = {
  'Market Cap': 'market_cap',
  'Enterprise Value': 'enterprise_value',
  'LTM Revenue': 'ltm_revenue',
  'LTM EBITDA': 'ltm_ebitda',
  'NTM Revenue': 'ntm_revenue',
  'NTM EBITDA': 'ntm_ebitda',
};

export const BACKSOLVE_TABLE_NAMES = {
  BACKSOLVE_SUMMARY: 'backsolveSummary',
  BACKSOLVE: 'backsolve',
  MARKET_ADJUSTMENT: 'marketAdjustment',
  OPM_INPUTS: 'opmInputs',
  SECURITIES: 'securities',
};

export const TABLE_HEADER_ROW = 0;
export const PRESENT_SHARE_VALUES_ROW_NUMBER = 5;

export const NO_STRING = 'NO';
export const YES_STRING = 'YES';

export const DEFAULT_MARKET_ADJUSTMENT_DECIMAL_PLACES = 4;
